import { render } from "./Dino.vue?vue&type=template&id=a39583b0"
import script from "./Dino.vue?vue&type=script&lang=js"
export * from "./Dino.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__